
import { defineComponent } from 'vue'
import { insurePeriodReportCaseListApi } from '@/api/long-insure-new'
import { BillDetailDto, BillDto } from '@/api/bill'
import { payrollDelete } from '@/api/payroll'
import batchPayroll from '@/components/batch-payroll.vue'
import addMaterial from '@/components/add-material.vue'
import { getMaterialInsureCompany } from '@/api/add-material.ts'

export default defineComponent({
  name: 'LongInsureReport',
  components: {
    batchPayroll,
    addMaterial
  },
  data() {
    return {
      isBatchPay: false,
      pageSize: 10,
      pageNum: 1,
      total: 0,
      tableData: [] as BillDetailDto[],
      searchText: '',
      searchValue: '',
      detailInfo: {} as BillDto,
      selects: [] as string[],
      curItem: {},
      showAdd: false,
      insureCompanyList: [] as any,
      uploadStatus: ''
    }
  },
  computed: {
    canShow() {
      return (insureCompanyType: string) => {
        return this.insureCompanyList.some((i: string) => i === insureCompanyType)
      }
    }
  },
  async created() {
    this.insureCompanyList = (await getMaterialInsureCompany()) || []
    this.getPayrollList()
  },
  methods: {
    async getPayrollList() {
      const result = await insurePeriodReportCaseListApi({
        insureType: 2,
        searchText: this.searchValue,
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        uploadStatus: this.uploadStatus
      })
      this.total = result.totalCount
      this.tableData = result.list
    },
    handleSizeChange() {
      this.pageNum = 1
      this.getPayrollList()
    },
    onAdd() {
      console.log('onAdd')
      this.$router.push({
        path: '/long-insure-report-add',
        query: {
          insureType: 2
        }
      })
    },
    search() {
      this.searchValue = this.searchText
      this.pageNum = 1
      this.getPayrollList()
    },
    onReset() {
      this.searchText = ''
      this.search()
    },
    handleSelectionChange(selects: { id: string }[]) {
      this.selects = selects.map((item) => item.id)
    },
    /**
     * 删除勾选工资单
     */
    async onDelete() {
      const str = this.selects.join(',')
      if (str.length === 0) {
        this.$message.warning('请至少选择一个！')
        return
      }
      await payrollDelete(str)
      this.getPayrollList()
      this.$message.success('删除成功！')
    },
    showAddMaterial(item: any) {
      this.curItem = item
      this.showAdd = true
    }
  }
})
